import React, { Fragment } from 'react';

import * as Actions from 'accounts/components/list/actions';

const AccountsActions = ({ permissions, account, company, subcompany, handleToggle }) => {
  return (
    <Fragment>
      {permissions['acl.accounts.toggle'] && (
        <Actions.Toggle account={account} handleClick={handleToggle} />
      )}
      {permissions['acl.accounts.update'] && (
        <Actions.Edit account={account} company={company} subcompany={subcompany} />
      )}
    </Fragment>
  );
};

export default AccountsActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/components/list/AccountsActions.js